import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import Card from 'components/Card';
import ModalHeadline from 'components/ModalHeadline';
import Panel from 'components/Panel';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Button from 'components/Button';
import BulletList from 'components/BulletList';
function CircularReferenceInfoModal(_ref) {
  var circularPlaylists = _ref.circularPlaylists,
    onCloseModal = _ref.onCloseModal,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = 'circular-reference-info-title';
  return /*#__PURE__*/React.createElement(Modal, {
    id: "circular-reference-info",
    "aria-labelledby": titleId,
    onRequestClose: function onRequestClose() {
      return onCloseModal();
    }
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised",
    px: "xs"
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: t('modal_circular_reference_title'),
    titleId: titleId,
    onClose: function onClose() {
      return onCloseModal();
    }
  }), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, t('modal_circular_reference_intro')), /*#__PURE__*/React.createElement(BulletList, null, circularPlaylists), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, t('modal_circular_reference_outro')))), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return onSubmit();
    }
  }, t('actions_ok')))));
}
export default CircularReferenceInfoModal;